export const NPAPOPUP="NPAPOPUP"
export const NPAPOPUP_SUCCESS="NPAPOPUP_SUCCESS"
export const NPAPOPUP_FAIL="NPAPOPUP_FAIL"

export const NPA_ACTION_DELETE = "NPA_ACTION_DELETE";
export const NPA_ACTION_DELETE_SUCCESS = "NPA_ACTION_DELETE_SUCCESS";
export const NPA_ACTION_DELETE_FAIL = "NPA_ACTION_DELETE_FAIL";